import {
  Avatar,
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  styled,
  TextField,
  TextFieldProps,
  Typography,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { User } from "../../../Shared-ui/Types/User";
import { userInitial } from "../../../Shared-ui/Store/UserReducer/UserReducer";
import {
  isOnlyAlphabets,
  isWebsiteAddress,
} from "../../../Shared-ui/utils/Common/Common";
import {
  ValidateEmailIsOrg,
  ValidateIsEmail,
} from "../../../Shared-ui/utils/Auth/AuthHelpers";
import { useDispatch } from "react-redux";
import { setUserData } from "../../../Shared-ui/Store/UserReducer/UserActions";
import userContext from "../../../Shared-ui/Context/UserContext";
import AuthInstance from "../../../Services/AxiosInstance/AuthInstance";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { ME, MFA_DISABLE, MFA_SETUP, USERS, UPLOAD_PROFILE_IMAGE, DELETE_PROFILE_IMAGE } from "../../../Services/Endpoint";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { ADMIN_USERS, ADMIN_ORGANIZATIONS } from "../../../Services/Endpoint";
import { SelectChangeEvent } from "@mui/material";
import MFAPopup from "../MFAPopup";




interface MyComponentProps { }

const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  '& input[type="number"]': {
    "-moz-appearance": "textfield", // Firefox
    "-webkit-appearance": "none", // Chrome/Safari
    appearance: "none", // Standard appearance reset
  },
  "& input::-webkit-outer-spin-button": {
    appearance: "none", // Disable the spinner
    margin: 0, // Reset the margin
  },
  "& input::-webkit-inner-spin-button": {
    appearance: "none", // Disable the spinner
    margin: 0, // Reset the margin
  },
}));

const UserProfileData: React.FC<MyComponentProps> = () => {
  const errorInitial = {
    email: { error: "", value: false },
    full_name: { error: "", value: false },
    organization: { error: "", value: false },
    website: { error: "", value: false },
    address: { error: "", value: false },
  };

  const dispatch = useDispatch();
  const { user, updateUserContext } = useContext(userContext);
  // Profile Image Upload
  const [image, setImage] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [userForm, setUserForm] = useState<User>({
    ...userInitial,
    website: "",
    address: "",
    image: "",
  });
  const [userFormEr, setUserFormEr] = useState(errorInitial);
  const [organizations, setOrganizations] = useState<{ id: string; name: string }[]>([]);
  const [showMFAForm, setShowMFAForm] = useState(false);
  const [enableOrDisableMFA, setEnableOrDisableMFA] = useState<string>("");
  const [qrCodeData, setQrCodeData] = useState<{ qr_code: string; secret: string }>({ qr_code: "", secret: "" });


  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const res = await BaseInstance.get(ADMIN_ORGANIZATIONS);
        setOrganizations(res.data.items || []);
      } catch (err) {
        console.error("Failed to fetch organizations", err);
      }
    };

    fetchOrganizations();
  }, []);

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;
    setUserForm((prev) => ({ ...prev, [name!]: value }));
  };

  const selectedOrgName = organizations.find(
    (org) => org.id === userForm.organization_id
  )?.name || userForm.organization_id;

  <TextField
    disabled
    value={selectedOrgName}
  />


  useEffect(() => {
    setUserForm(user);
    console.log("User data loaded:", user);
    console.log("User image from database:", user.image);
  }, [user]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    const { name, value } = event.target;

    if (name === "image" && file) {
      // Only allow JPG, PNG, SVG formats (by MIME type)
      const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, PNG, and SVG formats are allowed.");
        setImage(null);
        setSelectedFile(null);
        event.target.value = '';
        return;
      }

      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl); // Update state with the uploaded image URL for preview
      setSelectedFile(file); // Store the actual file for upload
      console.log("Image uploaded, file:", file);
      console.log("Image uploaded, blob URL:", imageUrl);
    } else {
      setUserForm((preVal) => ({ ...preVal, [name]: value }));
    }
  };

  const validateUserForm = () => {
    console.log("Validating form with data:", userForm);
    
    let error = 0
    const setError = (field: string, condition: boolean, message: string) => {
      if (condition) {
        setUserFormEr(prev => ({
          ...prev,
          [field]: { error: message, value: true }
        }));
        error += 1;
      } else {
        setUserFormEr(prev => ({
          ...prev,
          [field]: { error: "", value: false }
        }));
      }
    };

    // email validation - check if email is provided and valid
    if (!userForm.email.trim()) {
      setError("email", true, "Email is required");
    } else if (!ValidateIsEmail(userForm.email)) {
      setError("email", true, "Please enter a valid email address");

    } else {
      setError("email", false, "");
    }

    // name validation
    if (!userForm.full_name.trim()) {
      setError("full_name", true, "Name is required");
    } else if (userForm.full_name.length < 4 || userForm.full_name.length > 40) {
      setError("full_name", true, "Please enter between 4 and 40 characters");
    } else if (!isOnlyAlphabets(userForm.full_name)) {
      setError("full_name", true, "Numbers and special characters are not allowed");
    } else {
      setError("full_name", false, "");
    }
    // website validation - only validate if website is provided
    if (userForm.website && userForm.website.trim()) {
      setError("website", !isWebsiteAddress(userForm.website), "Please enter valid website url");
    } else {
      setError("website", false, "");
    }

    console.log("Validation result - errors:", error);
    return error === 0 ? true : false
  };

  const uploadImage = async (file: File): Promise<string | null> => {
    try {
      console.log("Uploading image file:", file.name);
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await BaseInstance.post(UPLOAD_PROFILE_IMAGE, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      console.log("Image upload successful:", response.data);
      return response.data.image_url;
    } catch (err: any) {
      console.error("Image upload failed:", err);
      throw err;
    }
  };

  const updateUser = async () => {
    console.log("Save button clicked, starting update process...");
    console.log("Current userForm data:", userForm);
    console.log("Selected file:", selectedFile);
    
    if (validateUserForm()) {
      console.log("Validation passed, making API call...");
      try {
        dispatch(StartLoading());
        
        let imageUrl = userForm.image; // Use existing image URL
        
        // Upload new image if one was selected
        if (selectedFile) {
          console.log("Uploading new image...");
          const uploadedImageUrl = await uploadImage(selectedFile);
          imageUrl = uploadedImageUrl || imageUrl;
          console.log("New image URL:", imageUrl);
        }
        
        // Update user data with the image URL
        const userDataToUpdate = {
          ...userForm,
          image: imageUrl || undefined
        };
        
        console.log("Making PUT request to:", ME);
        console.log("Sending data:", userDataToUpdate);
        
        const data = await BaseInstance.put(ME, userDataToUpdate).then(
          (res) => res?.data
        );
        console.log("API call successful, response:", data);
        
        dispatch(ShowSuccess("user updated"));
        //  TO update user context after userform update
        updateUserContext();
      } catch (err: any) {
        console.error("API call failed:", err);
        console.error("Error response:", err?.response?.data);
        dispatch(ShowError(err?.response?.data?.detail || "Failed to update user profile"));
      } finally {
        dispatch(StopLoading());
      }
    } else {
      console.log("Validation failed, not making API call");
    }
  };


  const setupMFA = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.post(MFA_SETUP).then(
        (res) => res?.data
      );
      setQrCodeData(data)
      setEnableOrDisableMFA("enable");
      setShowMFAForm(true)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }

  }


  const disableMFA = async () => {
    setEnableOrDisableMFA("disable");
    setShowMFAForm(true);

  }

  const [isDeletingImage, setIsDeletingImage] = useState(false);

  // helper to safely clear local preview
  const clearLocalPreview = () => {
    try {
      if (image?.startsWith("blob:")) URL.revokeObjectURL(image);
    } catch {}
    setImage(null);
    setSelectedFile(null);
  };

  const handleDeleteImage = async () => {
    try {
      dispatch(StartLoading());

      // call backend to actually delete
      await BaseInstance.delete(DELETE_PROFILE_IMAGE);

      // clear from local state & context
      setImage(null);
      setUserForm((prev) => ({ ...prev, image: "" }));
      updateUserContext();

      dispatch(ShowSuccess("Profile photo removed"));
    } catch (err: any) {
      console.error("Failed to delete profile image:", err?.response?.data || err);
      dispatch(
        ShowError(err?.response?.data?.detail || "Failed to remove profile photo")
      );
    } finally {
      dispatch(StopLoading());
    }
  };

  const organizationName = organizations.find((org) => org.id === user.organization_id)?.name || "N/A";

  return (
    <>
      <Typography variant="h6">Profile</Typography>
      <Typography variant="body2">
        Update your photo and personal details here.
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Box
        sx={{
          display: "flex",
          flexDirection: { md: "row", sm: "row", xs: "column" },
          mb: "30px",
          gap: "30px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 120,
            height: 120,
            "&:hover .delete-btn": { opacity: 1 },
          }}
        >
          <Avatar
            src={image || userForm.image || undefined}
            sx={{
              width: 120,
              height: 120,
              borderRadius: "10px",
            }}
            alt="Profile Picture"
          />

          <Button
            className="delete-btn"
            onClick={handleDeleteImage}
            disabled={isDeletingImage}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              minWidth: 0,
              width: 32,
              height: 32,
              borderRadius: "50%",
              opacity: 0,
              transition: "opacity 0.3s",
              backgroundColor: "rgba(0,0,0,0.5)",
              color: "white",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
            }}
            title="Delete profile photo"
            aria-label="Delete profile photo"
          >
            {isDeletingImage ? "…" : "🗑️"}
          </Button>
        </Box>

        <Button
          disableElevation
          variant="contained"
          component="label"
          sx={{ textTransform: "none" }}
        >
          Upload Image
          <input
            type="file"
            name="image"
            hidden
            accept="image/*"
            onChange={handleChange}
          />
        </Button>

        <Box sx={{ ml: { md: "auto", xs: 0 }, gap: 2, display: 'flex', flexDirection: { md: 'row', sm: 'column', xs: 'column' } }}>

          <Button variant="contained" onClick={() => setupMFA()} disabled={user.mfa_enabled}>
            Enable MFA
          </Button>
          <Button variant="contained" color="error" onClick={disableMFA} disabled={!user.mfa_enabled}>
            Disable MFA
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { md: "row", sm: "column", xs: "column" },
          width: "100%",
          gap: "30px",
          mb: "30px",
        }}
      >
        <FormControl fullWidth variant="outlined" error={userFormEr.full_name.value}>
          <InputLabel
            htmlFor="full_name"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Name
          </InputLabel>
          <TextField
            id="full_name"
            name="full_name"
            value={userForm.full_name}
            placeholder="Name"
            onChange={handleChange}
            sx={{ background: "white" }}
            error={userFormEr.full_name.value}
            inputProps={{ maxLength: 40 }}
            helperText={userFormEr.full_name.error}
          />
        </FormControl>

        <FormControl
          fullWidth
          variant="outlined"
          error={userFormEr.email.value}
        >
          <InputLabel
            htmlFor="email"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Business Email
          </InputLabel>
          <TextField
            id="email"
            name="email"
            type="email"  
            value={userForm.email}
            placeholder="Email"
            onChange={handleChange}
            sx={{ background: "white" }}
            error={userFormEr.email.value}
            helperText={userFormEr.email.error}
          />
        </FormControl>
      </Box>
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: { md: "row", sm: "column", xs: "column" },
          width: "100%",
          gap: "30px",
          mb: "30px",
        }}
      >
        <FormControl
          fullWidth
          variant="outlined"
          error={userFormEr.organization.value}
        >
          <InputLabel
            htmlFor="organization"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Organization
          </InputLabel>
           <Select
              id="organization"
              name="organization_id"
              value={userForm.organization_id}
              onChange={handleSelectChange}
              displayEmpty
              sx={{ background: "white" }}
            >
            <MenuItem value="" disabled>Select organization</MenuItem>
                {organizations.map((org) => (
            <MenuItem key={org.id} value={org.id}>
                {org.name}
            </MenuItem>
                ))}
            </Select>

        </FormControl>

        <FormControl
          fullWidth
          variant="outlined"
          error={userFormEr.website.value}
        >
          <InputLabel
            htmlFor="website"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Website
          </InputLabel>
          <TextField
            id="website"
            name="website"
            onChange={handleChange}
            value={userForm.website}
            placeholder="Website"
            sx={{ background: "white" }}
            error={userFormEr.website.value}
            helperText={userFormEr.website.error}
          />
        </FormControl>
      </Box> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { md: "row", sm: "column", xs: "column" },
          width: "100%",
          gap: "30px",
          mb: "30px",
        }}
      >
        {/* <FormControl
          fullWidth
          variant="outlined"
          error={userFormEr.address.value}
        >
          <InputLabel
            htmlFor="address"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Address
          </InputLabel>
          <TextField
            id="address"
            multiline
            name="address"
            onChange={handleChange}
            value={userForm.address}
            placeholder="Address"
            sx={{
              background: "white",
              "& textarea": {
                height: "100px", // Set a fixed height
                overflowY: "auto", // Enable vertical scrolling when content overflows
              },
            }}
            error={userFormEr.address.value}
            helperText={userFormEr.address.error}
          />
        </FormControl> */}
        <FormControl
          fullWidth
          variant="outlined"
        >
          <InputLabel
            htmlFor="user"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Super User
          </InputLabel>
          <StyledTextField
            id="user"
            name="user"
            type="text"
            disabled
            value={user.is_superuser ? "Yes" : "No"}
            // onChange={handleChange}
            placeholder="Phone"
            sx={{
              background: "white",
            }}
          />
        </FormControl>

        <FormControl
          fullWidth
          variant="outlined"
        >
          <InputLabel
            htmlFor="organization"
            shrink
            sx={{ background: "#fff", px: 0.5 }}
          >
            Organization
          </InputLabel>
          <TextField
            id="organization"
            name="organization"
            value={organizationName}
            placeholder="Organization"
            InputProps={{
              readOnly: true,
            }}
            sx={{
              background: "white",
            }}
          />
        </FormControl>

      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="contained"
          disableElevation
          size="large"
          sx={{
            textTransform: "capitalize",
            minWidth: "140px",
          }}
          onClick={updateUser}
        >
          Save
        </Button>
      </Box>

      {showMFAForm && <MFAPopup showMFAForm={showMFAForm} setShowMFAForm={setShowMFAForm} enableOrDisableMFA={enableOrDisableMFA} qrCodeData={qrCodeData} />}
    </>
  );
};

export default UserProfileData;
